import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
//import { PublicRoute, PrivateRoute } from './AuthRoot';
import SignInScreen from '../../screens/Register/signIn';
import TwoAuthVerify from '../../screens/Register/2faAuth';
import RegisterUser from '../../screens/Register/registerUser';
import Patients from '../../screens/Patients/Patients';
//import { useSelector } from 'react-redux';
import MainComponent from '../../components/mainComponent';
import ConsentForm1 from '../../screens/Patients/consentForm1';
import ConsentForm2 from '../../screens/Patients/consentForm2';
import TalkToProvider from '../../screens/Patients/talkToProvider';
import MedicalHistory from '../../screens/Patients/medicalHistory';
import MedicalCondition from '../../screens/Patients/medicalCondition';
import Symptoms from '../../screens/Patients/symptoms';
import LobbyScreen from '../../screens/Patients/lobby';
import LobyComponent from '../../components/lobbyComponent';
import ThankYou from '../../screens/ThankYou/thankYou';
import PrivateRoutes from './PrivateRoutes';
import PrivateRegisterRoutes from './PrivateRegisterRoutes';
import PrivateVerifyRoutes from './PrivateVerifyRoute';
import RegisterSuccessfull from '../../screens/Register/registerSuccessfull';

const RootRouter = () => {
    //const navigate = useNavigate();
    // const isAuthenticated = useSelector(state => state.registerReducer.userVerifyData);
    // const isPublicAuth = useSelector(state => state.registerReducer.validData);
    // const [isAuthenticated, setIsAuthenticated] = useState(false);
    // const [isPublicAuth, setIsPublicAuth] = useState(false);
    // useEffect(() => {
    //     if (userData && userData.token) {
    //         setIsAuthenticated(true);
    //     } else {
    //         setIsAuthenticated(false);
    //     }
    // }, [userData]);
    // useEffect(() => {
    //     if (validData) {
    //         setIsPublicAuth(true);
    //     } else {
    //         setIsPublicAuth(false);
    //     }
    // }, [validData]);
    // const onRedirectTo = (value) =>{
    //     navigate(value);
    // }
    return (
        <Routes>
            {/* <PublicRoute restricted={false} component={() => <SignInScreen />} path="room/medical" />
            <PrivateRoute restricted={isPublicAuth} component={() => <TwoAuthVerify />} path="room/veriy" /> */}
            <Route element={<MainComponent Component={() => <SignInScreen />} />} path='/' />
            <Route element={<PrivateVerifyRoutes />}>
                <Route element={<MainComponent Component={() => <TwoAuthVerify />} />} path='/room/verify' />
            </Route>
            <Route element={<PrivateRegisterRoutes />}>
                <Route element={<MainComponent Component={() => <RegisterUser />} />} path='/room/register' />
                <Route element={<MainComponent Component={() => <RegisterSuccessfull />} />} path='/room/success' />
            </Route>
            {/* <Route element={<SignInScreen />} path='room/medical' />
            <Route element={<TwoAuthVerify />} path='/room/verify' />
            <Route element={<RegisterUser />} path='/room/register' /> */}
            <Route element={<PrivateRoutes />}>
                <Route element={<MainComponent Component={() => <Patients />} />} path='/room/patient' />
                <Route element={<MainComponent Component={() => <ConsentForm1 />} />} path='/room/user' />
                <Route element={<MainComponent Component={() => <MedicalHistory />} />} path='/room/medicalHistory' />
                <Route element={<MainComponent Component={() => <MedicalCondition />} />} path='/room/medicalCondition' />
                <Route element={<MainComponent Component={() => <Symptoms />} />} path='/room/symptoms' />
                <Route element={<LobyComponent Component={() => <LobbyScreen />} />} path='/room/preview' />
                {/* <Route element={<LobbyScreen />} path='/room/preview' /> */}
                <Route element={<TalkToProvider />} path='/room/livecall' />
                <Route element={<MainComponent Component={() => <ThankYou />} />} path='/room/thanks' />
            </Route>

            {/* <Route element={<MedicalHistory />} path='/room/medicalHistory' /> */}
            {/* <Route element={<MainComponent Component={() => <ConsentForm2 />} />} path='/room/user' /> */}
        </Routes>
    );
}
export default RootRouter;